import { useQuery } from '@tanstack/react-query'
import DataCard from './data_card'
import { statusColors } from '../../constants/status_colour_map'

const DataSizeCard = ({ cycleID }) => {
  const { data: sizes, isLoading, error } = useQuery([`cycles/`, cycleID, `/get-data-sizes`])

  return (
    <DataCard title='Data' pending={isLoading} error={error}>
      <div className='flex flex-row justify-between'>
        {sizes?.data?.map((item, index) => (
          <div className='px-6' key={index}>
            <p className='text-3xl'>{item?.size}</p>
            <p className={`${statusColors[item?.status.toLowerCase()] || ''}`}>{item?.status}</p>
          </div>
        ))}
      </div>
    </DataCard>
  )
}

export default DataSizeCard
